import { TwBfInput, TwBfLocation, TwBfLocationSelectType, TwBfPhone } from '@tw/tw-platform-rn';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { TwCheckbox, TwFormItem } from '@tw/tw-components-rn';

import { AddressProps } from '../../type';
import React from 'react';
import { View } from 'react-native';
import { styles } from './styles';

interface AddressInitProps {
  value: AddressProps;
  onChange: (value: AddressProps) => void;
}

export const AddressInit = (props: AddressInitProps) => {
  return (
    <View style={styles.container}>
      <TwFormItem
        style={styles.item}
        labelStyle={styles.label}
        label={'联系人'}
        pressable={true}
        readOnly={false}
        required={true}
        layout="vertical"
      >
        <TwBfInput
          value={props.value.name}
          placeholder="请输入姓名"
          onChange={(value) => {
            props.onChange({ ...props.value, name: value });
          }}
        ></TwBfInput>
      </TwFormItem>
      <TwFormItem
        style={styles.item}
        labelStyle={styles.label}
        label={'手机号'}
        required={true}
        pressable={true}
        layout="vertical"
      >
        <TwBfPhone
          value={props.value.phone}
          placeholder="配送员联系您的手机号码"
          onChange={(value) => {
            props.onChange({ ...props.value, phone: value });
          }}
        ></TwBfPhone>
      </TwFormItem>
      <TwBfLocation
        required={true}
        style={styles.item}
        labelStyle={styles.label}
        title={'收货地址'}
        detailAddressTitle="详细地址"
        defaultSelectType={TwBfLocationSelectType.area}
        value={props.value.address}
        onChange={(value) => {
          props.onChange({ ...props.value, address: value });
        }}
      ></TwBfLocation>
      <TwFormItem style={styles.item} label={'设为默认地址'} labelStyle={styles.label} contentAlign={'right'}>
        <TwCheckbox
          checked={props.value.isDefault}
          onChange={(value) => {
            props.onChange({ ...props.value, isDefault: value });
          }}
        ></TwCheckbox>
      </TwFormItem>
    </View>
  );
};
